/* eslint-disable no-console, linebreak-style */
import _ from 'underscore';
import * as SwatchbookUtils from './modules/swatchbook-utils';
import { getItemsFromAccount } from './modules/consumer-account/storage-actions';

console.log('\n\n\n*************************\n\nswatchcart.js ver: 1.0.15 \n\n*************************\n\n\n');

window.SwatchbookUtils = SwatchbookUtils;

let swatchOrderItem = 0;
let existingOrderItem = 0;
let orderCt = 0;
let existingOrder = [];

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const noSwatchesTemplate =
  `<div class="swatchbook-no-content">
    <div>
      Your Bali Swatch Cart is currently empty. Browse through a wide variety of swatches and get free samples of the Bali window treatments that match your style.
      <br /><br />
    </div>
    <a href="/swatches/" class="btn btn-secondary">Browse Swatches</a>
  </div>`;

const swatchTemplate =
  `<li class="cart--content">
    <div class="form--checkbox">
      <input type="checkbox" id="{{ id }}" data-imageurl="{{ imageUrl }}" name="{{ colorName }}" value="{{ colorName }}" checked="">
      <label for="{{ id }}" class="checkbox--label"><span class="sr-only">Add/Remove {{ colorName}} {{ colorNumber }} swatch</span></label>
    </div>
    <div class="cart--image">
      <img src="{{ imageUrl }}" alt="{{ colorName }} {{ colorNumber }} swatch preview" />
    </div>
    <div class="cart--description">
      <h3>{{ colorName }}</h3>
      <div class="cart-item-filters">
        {{ colorNumber }} &bull; {{ collection }} &bull; {{ productLine }} &bull; {{ swatchCatName }}
        {{ (displayMessage !== '' ? '<br><span class="display-message">' + displayMessage + '</span>' : '') }}
      </div>
    </div>
    <div class="cart--price">$0.000</div>
  </li>`;

const swatchTemplateVals = _.template(swatchTemplate);

const updateCartTotal = (total) => {
  document.querySelector('#cart-total').innerHTML = total;
};

const buildCart = (data) => {
  const selector = document.querySelector('.cart--list');
  let d = null;
  if (data.length === 0) {
    d = document.createElement('div');
    d.innerHTML = noSwatchesTemplate;

    Array.from(d.children).forEach((child) => {
      if (child.tagName === 'LI') {
        selector.appendChild(child);
      } else {
        const li = document.createElement('li');
        li.appendChild(child);
        selector.appendChild(li);
      }
    });
  } else {
    data.forEach((item) => {
      const compiled = swatchTemplateVals(item);
      d = document.createElement('div');
      d.innerHTML = compiled;

      Array.from(d.children).forEach((child) => {
        if (child.tagName === 'LI') {
          selector.appendChild(child);
        } else {
          const li = document.createElement('li');
          li.appendChild(child);
          selector.appendChild(li);
        }
      });
      // Default add all to cart
      SwatchbookUtils.addSwatchToCart(item.id);
    });
  }
};

const proceedToCheckout = () => {
  const { isAuthenticated, useLocalStorage } = window;
  if (useLocalStorage) { // For Costco sites
    window.location = window.checkoutUrl;
    return;
  }
  if (isAuthenticated) {
    window.location = window.checkoutUrl;
  } else {
    window.location = window.checkoutLoginUrl;
  }
};

const addSwatchToOrder = () => {
  if (swatchOrderItem >= orderCt) {
    // Update order
    SwatchbookUtils.updateOrderData(SwatchbookUtils.getSwatchbookData().cart);
    // Advance to checkout
    proceedToCheckout();
  } else {
    const params = document.querySelectorAll('.cart--list :checked')[swatchOrderItem].getAttribute('id').split('-');
    const imageUrl = document.querySelectorAll('.cart--list :checked')[swatchOrderItem].getAttribute('data-imageurl');
    swatchOrderItem += 1;
    console.log(`cart-utils.js, addSwatchToOrder, ${swatchOrderItem}/${orderCt}`);
    console.log(`${null}, ${params[1]}, ${params[2]}, ${params[3]}, ${false}, ${SwatchbookUtils.getTruncatedWidenUrl(imageUrl)}`);
    window.AddSwatch(null, params[1], params[2], params[3], false, SwatchbookUtils.getTruncatedWidenUrl(imageUrl), addSwatchToOrder);
  }
};

const getExistingOrderDataFromCookie = () => {
  // Use cookie data instead of localstorage
  const regex = new RegExp('swatchItems=(.*?)(;|$)', 'gi');
  let arr = regex.exec(document.cookie.toString());
  /* eslint-disable prefer-destructuring */
  // return SwatchbookUtils.getSwatchbookData().order;
  /* eslint-enable prefer-destructuring */
  if (arr === null) {
    return [];
  }
  arr = decodeURIComponent(arr[1]);
  arr = arr.split(',');
  for (let i = 0; i < arr.length; i++) { /* eslint-disable-line no-plusplus */
    // Re-format id to match expected formatting
    const itemArr = arr[i].split('_');
    arr[i] = `swatch-${itemArr[0]}-${itemArr[2]}-${itemArr[1]}`;
  }
  console.log(arr);
  return arr;
};

const removeSwatchFromOrder = () => {
  if (existingOrderItem >= existingOrder.length) {
    // Remove cookie created by existing logic
    document.cookie = 'swatchItems=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    // Add swatches
    addSwatchToOrder();
  } else {
    const params = existingOrder[existingOrderItem].split('-');
    existingOrderItem += 1;
    console.log(`cart-utils.js, removeSwatchFromOrder, ${existingOrderItem}/${existingOrder.length}`);
    console.log(params);
    console.log(`${null}, ${params[1]}, ${params[2]}, ${params[3]}, ${false}, ''`);
    window.RemoveSwatch(null, params[1], params[2], params[3], false, '', removeSwatchFromOrder);
  }
};

const addSwatchesToExistingOrderLogic = () => {
  existingOrder = getExistingOrderDataFromCookie();
  console.log(existingOrder);
  // Remove any existing swatches in order, then add
  removeSwatchFromOrder();
};

const checkout = () => {
  // Gather all checked items and add to cart, check swatches in order against max allowed
  orderCt = document.querySelectorAll('.cart--list :checked').length;
  if (orderCt !== 0 && orderCt <= window.cartMaxCt) {
    // Block out screen
    window.BlockUI();
    // Reseting counters
    swatchOrderItem = 0;
    existingOrderItem = 0;
    // console.log('Reset swatchOrderItem, existingOrderItem');
    addSwatchesToExistingOrderLogic();
  }
};

const setCheckoutState = () => {
  orderCt = document.querySelectorAll('.cart--list :checked').length;
  // orderCt = SwatchbookUtils.getAllOfType('swatch').length;
  updateCartTotal(orderCt);
  const btnList = document.querySelectorAll('.checkout-button');
  const warningList = document.querySelectorAll('.swatch-limit-warning');
  for (let i = 0; i < btnList.length; i++) { /* eslint-disable-line no-plusplus */
    if (orderCt !== 0 && orderCt <= window.cartMaxCt) {
      // Remove disabled states, classes on checkout button, hide warning
      btnList[i].classList.remove('disabled-link');
      warningList[i].classList.add('hidden');
    } else {
    // Add disabled states, classes on checkout button, show warning
      btnList[i].classList.add('disabled-link');
      warningList[i].classList.remove('hidden');
    }
  }
};

const addButtonHandlers = () => {
  // Set checkout button state
  setCheckoutState();
  // Add checkout handler
  if (document.querySelectorAll('.checkout-button')) {
    [].map.call(document.querySelectorAll('.checkout-button'), btn => btn.addEventListener('click', () => {
      checkout();
      // proceedToCheckout();
    }));
  }
  // Add checked handler for checkboxes
  [].map.call(document.querySelectorAll('.form--checkbox input'), btn => btn.addEventListener('click', () => {
    // Add/remove swatch from cart based on status
    // console.log(`${btn.checked} / ${btn.getAttribute('id')}`);
    if (btn.checked) {
      SwatchbookUtils.addSwatchToCart(btn.getAttribute('id'));
    } else {
      SwatchbookUtils.removeSwatchFromCart(btn.getAttribute('id'));
    }
    setCheckoutState();
  }));
};

// Initialize
const init = () => {
  SwatchbookUtils.init();
  // If not logged-in, pull swatch data from local storage, otherwise pull from account data
  const { isAuthenticated } = window;
  if (isAuthenticated) {
    getItemsFromAccount('swatch', (data) => {
      // Map data for display
      const swatchData = data.swatches.map(item => ({
        colorName: item['color-name'],
        colorNumber: item['color-number'],
        collection: item['collection-name'],
        swatchCatName: item['swatch-category-name'],
        productLine: item['product-line'],
        displayMessage: item['display-message'],
        imageUrl: `${window.WidenSwatchBaseUrl}${item['widen-url']}`,
        id: `swatch-${item['style-id']}-${item['swatch-category-id']}-${item['swatch-id']}`,
      }));
      buildCart(swatchData);
      // Set number of swatches in cart
      console.log(swatchData.length);
      updateCartTotal(swatchData.length);
      addButtonHandlers();
    });
  } else {
    const lsSwatchData = SwatchbookUtils.getAllOfType('swatch');
    buildCart(lsSwatchData);
    // Set number of swatches in cart
    updateCartTotal(lsSwatchData.length);
    addButtonHandlers();
  }
};

export default {
  checkout,
  init,
};

if (document.querySelector('.cart-page')) {
  init();
}
/* eslint-enable no-console, linebreak-style */
